import { useQuery } from 'react-query';
import axios from '../../../utils/axios';
import { apiurl } from '../../../config/apiUrl';

const fetchAllPpeComponentMaster = (data) => {
  return axios.get(`${apiurl?.getAllPpeComponentMaster}?searchCriteria=${data?.searchCriteria}&Page=${data?.Page}&PageSize=${data?.PageSize}&isAll=${data?.isAll}`);
};

const getAllPpeComponentMaster = (data) => {
  return useQuery(['getAllPpeComponentMaster', data], () => fetchAllPpeComponentMaster(data), { refetchOnWindowFocus: false });
};

export default getAllPpeComponentMaster;
